export default __webpack_public_path__ + "static/media/step_2.58eec1bd.png";